import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh2';
export const locale = {
  lang: 'zh2',
  data: {
    'VOICE': {
      'ENABLE': '启用音轨进行调查',
      'TITULO': '语音设置',
      'SUBTITULO': '仅当启用了调查的音轨时，才会应用此设置。',
      'CONFIG_IDIOMA': {
        'TITULO': '此语言的当前设置',
        'GENERO': {
          'TITULO': '声音性别',
          'Femenino': '女性',
          'Masculino': '男性'
        },
        'TIPO_VOZ': {
          'TITULO': '语音类型',
          '1': '声音类型 1',
          '2': '语音类型 2',
          '3': '声音类型 3',
          '4': '语音类型 4',
          '5': '语音类型 5',
          '6': '语音类型 6',
          '7': '语音类型 7',
          '8': '语音类型 8',
          '9': '语音类型 9',
          '10': '声音类型 10',
        },
        'PRUEBA_VOZ': {
          'TITULO': '语音测试',
          'INSTRUCCION': '写一段文字来测试声音',
          'PLACEHOLDER': '语音测试文本',
          'PROBAR': '测试文本到语音'
        }
      },
      'MODALES': {
        'COMPLETAR': '您确定使用当前的语音选择完成了该步骤吗？',
        'COMPLETAR_OFF': '您确定要在禁用语音设置的情况下完成该步骤吗？',
        'INCOMPLETO': '您还没有对所有语言的声音进行完整选择，需要完成它才能继续',
        'PASO_COMPLETO': '步骤成功完成',
        'GENERANDO_AUDIOS': '语音设置正在应用到此产品的部分，请稍等'
      }
    }
  }
};
